import { render, staticRenderFns } from "./DocumentDurationSelector.vue?vue&type=template&id=1c6974b3&scoped=true&"
import script from "./DocumentDurationSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentDurationSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6974b3",
  null
  
)

export default component.exports